import { TextField } from "@mui/material";
import { inputsSetting } from 'utilities';
import styles from '../../styles.module.scss';

type Props = {
  title?: string;
  value?: number | string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
  placeholder?: string;
};

export const DetailsInput: React.FC<Props> = ({
  title,
  value,
  onChange,
  placeholder = "Enter information here"
}) => {
  return (
    <div className={styles.details__input}>
      <div className="inputWithTitle">
        <span>{title}</span>
        <TextField
          className="customInput"
          value={value || ''}
          onChange={onChange}
          variant="outlined"
          placeholder={placeholder}
          required
          sx={inputsSetting.sxWidth}
        />
      </div>
    </div>
  );
}
